(() => {
  const unavailableStyle = document.createElement('style');
  unavailableStyle.textContent = '.grid__item:has(.lktraz-unavailable-product),.slider__slide:has(.lktraz-unavailable-product){display:none!important}';
  document.head.append(unavailableStyle);
  const size = 24;
  const cache = new Map();
  let run = 0;
  let timer;
  function permittedUrl() {
    const url = new URL(location.href);
    const search = /\/search\/?$/.test(url.pathname);
    const collection = /\/collections\/[^/]+\/?$/.test(url.pathname);
    if (search && url.searchParams.get('options[unavailable_products]') !== 'hide') {
      url.searchParams.set('options[unavailable_products]', 'hide');
      location.replace(url.href);
      return null;
    }
    if (collection && url.searchParams.get('filter.v.availability') !== '1') {
      url.searchParams.set('filter.v.availability', '1');
      location.replace(url.href);
      return null;
    }
    return search ? url : null;
  }
  async function section(url, sectionId, query, page) {
    const request = new URL(url);
    request.searchParams.set('q', query);
    request.searchParams.set('page', String(page));
    request.searchParams.set('section_id', sectionId);
    request.searchParams.set('options[unavailable_products]', 'hide');
    const key = request.href;
    if (!cache.has(key)) cache.set(key, fetch(key, {signal: AbortSignal.timeout(15000)}).then(async response => {
      if (!response.ok) throw new Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const root = doc.querySelector('[data-lktraz-search-total]');
      if (!root) throw new Error('Search result metadata missing');
      const count = Number(root.dataset.lktrazSearchTotal);
      if (!Number.isFinite(count)) throw new Error('Search count invalid');
      return {count, cards: Array.from(root.querySelectorAll('ul.product-grid > li'))};
    }).catch(error => {cache.delete(key); throw error;}));
    return cache.get(key);
  }
  async function prioritise() {
    const url = permittedUrl();
    if (!url) return;
    const root = document.querySelector('#product-grid[data-lktraz-search-total]');
    const list = root?.querySelector('ul.product-grid');
    const q = url.searchParams.get('q')?.trim();
    if (!list || !q || root.dataset.lktrazPriorityKey === url.href) return;
    const currentRun = ++run;
    root.dataset.lktrazPriorityKey = url.href;
    root.setAttribute('aria-busy', 'true');
    try {
      // Keep the customer's original query: adding vendor clauses can broaden
      // Shopify's results. Partition only products returned for that exact query.
      const first = await section(url, 'lktraz-priority-results', q, 1);
      const pages = Math.ceil(first.count / 250);
      const results = [first];
      // Bound concurrency for broad searches.
      for (let page = 2; page <= pages; page += 4) {
        results.push(...await Promise.all(Array.from({length: Math.min(4, pages-page+1)}, (_, index) =>
          section(url, 'lktraz-priority-results', q, page+index))));
      }
      const all = results.flatMap(result => result.cards);
      if (all.length !== first.count) throw new Error('Incomplete search results');
      const own = all.filter(card => card.dataset.lktrazVendor === 'LKTRAZ Motors');
      const other = all.filter(card => card.dataset.lktrazVendor !== 'LKTRAZ Motors');
      const page = Math.max(1, Number(url.searchParams.get('page')) || 1);
      const offset = (page - 1) * size;
      const selected = [...own, ...other].slice(offset, offset + size);
      if (currentRun !== run || !root.isConnected || location.href !== url.href) return;
      const cards = selected.map(card => {
        const clone = document.importNode(card, true);
        clone.classList.remove('scroll-trigger', 'animate--slide-in');
        clone.removeAttribute('data-cascade');
        clone.querySelectorAll('.scroll-trigger').forEach(node => node.classList.remove('scroll-trigger', 'animate--slide-in'));
        return clone;
      });
      list.replaceChildren(...cards);
      root.dataset.lktrazPriority = 'complete';
    } catch (error) {
      root.dataset.lktrazPriority = 'failed';
      console.warn('LKTRAZ search priority could not be applied', error.message);
    } finally {
      root.removeAttribute('aria-busy');
    }
  }
  const schedule = () => {clearTimeout(timer); timer = setTimeout(prioritise, 80);};
  permittedUrl();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
  window.addEventListener('popstate', schedule);
})();
